const common = {
    /* 扩展组树形根节点ID*/
    extendGroupRootId: 'extendGroupRootId',
    extendGroupPic: 'extendGroup.png'
};
export default common;
